<template>
    <div class="wrapperFonts">
    <div   v-for="font in fonts" class="fontComponent cmpt">
       <label class="labl">
            <input :checked="currentFont==font"  name="font" type="radio" @change="changeFont(font,$event)" v-bind:value="font">
           <div :style="{'font-family':font}">{{label.translate_fonts[font]}}</div>
       </label>
    </div>
    </div>
</template>
<script>
   export default {
        data(){
            return {
                currentFont:this.label.font
            }
        },

       props   : ['fonts', 'label'],
       methods : {
           changeFont (font,event) {
               $jQuery( ".previewMessage" + this.label.uniqueId ).hide();
               event.preventDefault();
               this.currentFont = font;
           }
       },
       mounted(){
             this.currentFont = this.label.font;
       },
       watch : {
           currentFont : {
               handler : function( after, before ) {
                   var params = {
                       labelId : this.label.id,
                       font    : after
                   }
                   var currentFont = after;
                   this.$store.dispatch( 'changeFont', params );
                   this.$store.dispatch( 'setMasterText', {labelId : this.label.id} );
                   this.label.lines.forEach( (function( fontInstance ) {
                       return function( line ) {
                           if ( line['fontsize'] < line.min_font_size ) {
                            currentFont = before;
                               return false;
                           }
                       }
                   })( this ) );
                   if ( currentFont != after ) {
                       var params = {
                           labelId : this.label.id,
                           font    : this.currentFont
                       }
                       this.$store.dispatch( 'changeFont', params );
                       this.currentFont = after;
                   }
                    this.label.font = this.currentFont;
               }
           }
       }
   }
</script>
<style>
    .labl {
        min-width    : 100%;
        height       : 50px;
        display      : inline-block;
        float        : left;
        margin-right : 10px;
    }

    .labl > input { /* HIDE RADIO */
        visibility : hidden; /* Makes input not-clickable */
        position   : absolute; /* Remove input from document flow */
        width      : 0px;
    }

    .labl > input + div { /* DIV STYLES */    border-radius: 10px;
        background: #F9F9F9;
        box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.14);
        padding: 11px 5px 4px;
        min-height: 50px;
        text-align: center;
        border: solid 2px #F9F9F9;
        display: block;
        line-height: 25px;
        font-size: 16px;
        font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
    }

    .labl > input:checked + div,
    .labl:hover > input + div { /* (RADIO CHECKED) DIV STYLES */
        color           : #EA8D00;
        background      : #FFFFFF;
        box-shadow      : 0 1px 0 0 rgba(0, 0, 0, 0.14);
        border          : solid 2px #EA8D00;
        text-decoration : none !important;
    }

    .fontComponent {
        display : inline-flex;
        float   : left;
        width   : auto !important;
        min-width   : calc(33.33% - 27px);
        margin  : 0 27px 26px 0;
        align-content: center;
    }

    .wrapperFonts {
            width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    }

    @media only screen and (max-width : 767px) {
        .package-block .button {
            background-position : center !important;
        }
    }
    </style>



// WEBPACK FOOTER //
// src/components/Fonts/Font.vue